import script from "./SocialLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialLinks.vue?vue&type=script&setup=true&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=0e0bd261&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0bd261"]])

export default __exports__